import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import type { DenormalizedColumnEntity } from '@web/types';
import { ColumnWidthDirective } from './column-width.directive';

/** Diameter of the round grab button, and so the width of the hit strip. */
const CONTROL_WIDTH = 30;

@Component({
    selector: 'web-column-resize',
    templateUrl: './web-column-resize.component.html',
    styleUrls: ['./web-column-resize.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ColumnWidthDirective],
})
export class WebColumnResizeComponent {
    public readonly columnLeft = input.required<DenormalizedColumnEntity>();
    public readonly columnRight = input.required<DenormalizedColumnEntity>();
    public readonly columnGap = input<number>(0);
    public readonly isColumnWidthFlex = input<boolean>(false);

    public readonly changeWidthToLeftEvent = output<void>();
    public readonly changeWidthToRightEvent = output<void>();

    /**
     * The handle straddles the seam between the two columns, so it is pulled out
     * past its own edge by half its width plus half the gap it has to cover.
     */
    public readonly rightStyle = computed<number>(() => -(this.columnGap() + CONTROL_WIDTH) / 2);
}
